module.exports = __webpack_public_path__ + "static/media/bg-portabilidade.313e6a9d.png";